import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReportsModule } from '@modules/reports/reports.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MojoAvatarModule } from 'mojo-avatar';
import { MojoFeatureAccessModule } from 'mojo-feature-access';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';
import { FeatureFlagsModule } from 'mojo-feature-flags';
import { MojoMarkSearchPhraseModule } from 'mojo-mark-search-phrase';
import { MojoPrivilegesModule } from 'mojo-privileges';

import { AddButtonComponent } from '@layout/components/add-button/add-button.component';
import { MobileMenuComponent } from '@layout/components/mobile-menu/mobile-menu.component';
import { MaterialModule } from '@material/material.module';
import { NotificationsModule } from '@modules/notifications/notifications.module';
import { CompanyCardModule } from '@shared/company-card/company-card.module';
import { DropdownModule } from '@shared/dropdown/dropdown.module';
import { JobCardModule } from '@shared/job-card/job-card.module';
import { LoaderModule } from '@shared/loader/loader.module';
import { MaterialModalModule } from '@shared/material-modal/material-modal.module';
import { MojoInputModule } from '@shared/mojo-input/mojo-input.module';
import { UserCardModule } from '@shared/user-card/user-card.module';

import { GlobalSearchResultsComponent } from './components/global-search-results/global-search-results.component';
import { MobileGlobalSearchModalContentComponent } from './components/mobile-global-search-modal/mobile-global-search-modal-content.component';
import { MobileGlobalSearchModalComponent } from './components/mobile-global-search-modal/mobile-global-search-modal.component';
import { UserManagementComponent } from './components/user-menagement/user-management.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LayoutConfig } from './layout.abstract.config';
import { layoutConfig } from './layout.config';
import { LayoutEffects } from './store/layout.effects';
import { LAYOUT_TOKEN, layoutReducers } from './store/layout.reducer';
import { SharedDirectivesModule } from '@shared/directives';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    GlobalSearchResultsComponent,
    MobileGlobalSearchModalComponent,
    MobileGlobalSearchModalContentComponent,
    UserManagementComponent,
    AddButtonComponent,
    MobileMenuComponent,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(LAYOUT_TOKEN, layoutReducers),
    EffectsModule.forFeature([LayoutEffects]),
    RouterModule,
    MaterialModule,
    MojoInputModule,
    LoaderModule,
    UserCardModule,
    JobCardModule,
    CompanyCardModule,
    MaterialModalModule,
    MojoPrivilegesModule,
    NotificationsModule,
    FeatureFlagsModule,
    MojoAvatarModule,
    DropdownModule,
    MojoMarkSearchPhraseModule,
    MojoFeatureExtensionsModule,
    MojoFeatureAccessModule,
    ReportsModule,
    SharedDirectivesModule,
  ],
  providers: [
    {
      provide: LayoutConfig,
      useValue: layoutConfig,
    },
  ],
  exports: [HeaderComponent, FooterComponent],
})
export class LayoutModule {}
